import { render } from "./penndinMarkters.vue?vue&type=template&id=222003f2&scoped=true"
import script from "./penndinMarkters.vue?vue&type=script&lang=js"
export * from "./penndinMarkters.vue?vue&type=script&lang=js"

import "./penndinMarkters.vue?vue&type=style&index=0&id=222003f2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222003f2"]])

export default __exports__